const DB_NAME = "equipr-refcache";

function openDb() {
  return new Promise((res, rej) => {
    const r = indexedDB.open(DB_NAME, 1);
    r.onupgradeneeded = () => r.result.createObjectStore("cache", { keyPath: "key" });
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  });
}
const store = (db, mode) => db.transaction("cache", mode).objectStore("cache");
const req = (q) => new Promise((res, rej) => { q.onsuccess = () => res(q.result); q.onerror = () => rej(q.error); });

export async function sha256(text) {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(String(text)));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

export async function cachePut(key, data, pin) {
  const db = await openDb();
  const entry = { key, data, pin_hash: pin ? await sha256(pin) : null, cached_at: new Date().toISOString() };
  await req(store(db, "readwrite").put(entry));
}

export async function cacheGet(key) {
  const db = await openDb();
  return (await req(store(db, "readonly").get(key))) || null;
}

export async function cacheList() {
  const db = await openDb();
  return (await req(store(db, "readonly").getAll())) || [];
}

export async function cacheGetVerified(key, pin) {
  const entry = await cacheGet(key);
  if (!entry) return null;
  if (entry.pin_hash && (await sha256(pin || "")) !== entry.pin_hash) return null;
  return entry;
}
